import React from 'react';
import { View } from 'react-native';
import BoilerPlate from '../boilerPlate/BoilerPlate';
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, FontSizeTokens, IconSizeTokens, IconTokens, TypographyTypeDLS } from '@voltmoney/schema';
import Icon from '../../icon/Icon';
import Typography from '../../typography/Typography';
import { DSP_PAYMENT_STATUS } from '../constants';
import { addCommasToNumber } from '../utils';
import { isFontMobile } from '../../stack/utils';
import FailureNote from '../failureNote/FailureNote';
import ButtonDLSBase from '../../button/ButtonDLS.base';
const DspPaymentScreen = ({ height, dspPaymentStatus, currentOrderId, dspAmountCollected, paymentDate, retryPaymentAction, navigateDashboardAction, dspPaymentDate, triggerAction, }) => {
    let label = '';
    let icon = IconTokens.Warning;
    if (dspPaymentStatus === DSP_PAYMENT_STATUS.EXEEDED) {
        label = 'Maximum attempts exceeded';
        icon = IconTokens.Warning;
    }
    else if (dspPaymentStatus === DSP_PAYMENT_STATUS.CANCELLED) {
        label = 'Payment cancelled';
        icon = IconTokens.Warning;
    }
    else if (dspPaymentStatus === DSP_PAYMENT_STATUS.FAILED) {
        label = 'Payment failed';
        icon = IconTokens.SYSTEM_ERROR_DLS;
    }
    else if (dspPaymentStatus === DSP_PAYMENT_STATUS.IN_PROGRESS) {
        label = 'Payment in progress';
        icon = IconTokens.PendingRepay;
    }
    const footerChild = () => {
        return (React.createElement(View, null,
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Retry payment', onPress: async () => {
                        await triggerAction(retryPaymentAction);
                    }, isDisabled: false })),
            dspPaymentStatus !== DSP_PAYMENT_STATUS.IN_PROGRESS && React.createElement(View, { style: { marginTop: 12 } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.TERTIARY, label: 'Skip for now', onPress: async () => {
                        await triggerAction(navigateDashboardAction);
                    }, isDisabled: false }))));
    };
    const renderContent = () => {
        return (React.createElement(View, { style: { marginTop: 46 } },
            React.createElement(View, { style: { alignItems: 'center' } },
                React.createElement(Icon, { name: icon, size: IconSizeTokens.MD, color: ColorTokens.System_Warning }),
                React.createElement(View, { style: { marginTop: 16 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4R, label: label })),
                React.createElement(View, { style: {
                        marginTop: 8,
                        flexDirection: 'row',
                        alignItems: 'center',
                    } },
                    React.createElement(Typography, { label: `₹`, fontWeight: '700', color: ColorTokens.Grey_Night, fontSize: isFontMobile() ? FontSizeTokens.XXXXL : FontSizeTokens.XXL, lineHeight: isFontMobile() ? 40 : 32 }),
                    React.createElement(Typography, { label: `${addCommasToNumber(dspAmountCollected)}`, typeDLS: TypographyTypeDLS.H1B, color: ColorTokens.Grey_Night })),
                React.createElement(View, { style: { marginTop: 16 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: dspPaymentDate, color: ColorTokens.Grey_Charcoal }))),
            (dspPaymentStatus === DSP_PAYMENT_STATUS.IN_PROGRESS || dspPaymentStatus === DSP_PAYMENT_STATUS.FAILED) && (React.createElement(View, null,
                React.createElement(FailureNote, { status: dspPaymentStatus === DSP_PAYMENT_STATUS.IN_PROGRESS ? 'Pending' : 'Failed', failedTitle: 'Any amount deducted will be refunded by your bank in 3-5 business days.', progressTitle: 'Your repayment is being processed. Please wait while we confirm the status of your transaction.' }))),
            React.createElement(View, { style: { marginTop: 16, padding: 16, borderRadius: 12, borderWidth: 1, borderColor: '#E4E7EC', backgroundColor: '#F9FAFB' } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'Transaction reference number', color: ColorTokens.Grey_Charcoal }),
                React.createElement(View, { style: { marginTop: 2 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: currentOrderId, color: ColorTokens.Grey_Night })))));
    };
    return (React.createElement(BoilerPlate, { height: height, backgroundColor: ColorTokens.White, bottomChildren: React.createElement(React.Fragment, null, footerChild()) },
        React.createElement(React.Fragment, null, renderContent())));
};
export default DspPaymentScreen;
